module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_null_null@2x.bce6209f.png";